import React from 'react';
import { TouchableOpacity, View, StyleSheet } from 'react-native';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, } from '@voltmoney/schema';
import Typography from '../typography/Typography';
import Space from '../space/Space';
const LimitCardDefault = ({ id1, id2, isView, limitAmount, fetchedAmount, isDarkMode, label, action, triggerAction, secondarylabel }) => {
    const handleAction = () => {
        action &&
            triggerAction &&
            triggerAction(action);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: isDarkMode ? styles.darkContainerView : {
                width: '100%',
                backgroundColor: '#F9FAFB',
                borderRadius: 16,
                height: 170,
                borderColor: '#E4E7EC',
                borderWidth: 1,
                shadowColor: '#0C5637',
                shadowOpacity: 0.08,
                elevation: 40,
                shadowOffset: {
                    width: 10,
                    height: 10,
                },
                shadowRadius: 60,
            } },
            React.createElement(View, { style: isDarkMode ? styles.darkContainerSubView : {
                    backgroundColor: '#FFFFFF',
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    borderTopLeftRadius: 16,
                    borderTopRightRadius: 16,
                    borderBottomColor: '#E4E7EC',
                    borderBottomWidth: 1,
                    height: 102,
                    shadowColor: '#0C5637',
                    shadowOpacity: 0.1,
                    shadowOffset: {
                        width: 4,
                        height: 4,
                    },
                    shadowRadius: 10,
                } },
                React.createElement(Typography, { label: label, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, lineHeight: 18 }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignContent: 'center',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Secondary_100 }),
                    React.createElement(Typography, { id: id1, label: limitAmount, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Secondary_100 }))),
            React.createElement(View, { style: {
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    shadowColor: '#98A2B3CC',
                    backgroundColor: isDarkMode && '#121212'
                } },
                React.createElement(Typography, { label: secondarylabel, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal, lineHeight: 18 }),
                React.createElement(Space, { size: SizeTypeTokens.XS }),
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignContent: 'center',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            alignContent: 'center',
                        } },
                        React.createElement(Typography, { label: '₹', fontFamily: FontFamilyTokens.Inter, fontWeight: '700', fontSize: FontSizeTokens.MD, color: isDarkMode ? ColorTokens.White : ColorTokens.Black, lineHeight: 24 }),
                        React.createElement(Typography, { id: id2, label: fetchedAmount, fontFamily: FontFamilyTokens.Poppins, fontWeight: '700', fontSize: FontSizeTokens.MD, color: isDarkMode ? ColorTokens.White : ColorTokens.Black, lineHeight: 24 })),
                    isView ? (React.createElement(React.Fragment, null,
                        React.createElement(TouchableOpacity, { onPress: handleAction },
                            React.createElement(Typography, { label: 'View', fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, lineHeight: 24 })))) : (React.createElement(React.Fragment, null)))))));
};
export default React.memo(LimitCardDefault);
export { LimitCardDefault };
const styles = StyleSheet.create({
    darkContainerView: {
        width: '100%',
        backgroundColor: '#0D0D0D',
        borderRadius: 16,
        height: 170,
        borderColor: '#1E222A',
        borderWidth: 1,
        shadowColor: 'rgba(231, 244, 237, 0.08)',
        shadowOpacity: 0.08,
        elevation: 40,
        shadowOffset: {
            width: 10,
            height: 10,
        },
        shadowRadius: 60,
    },
    darkContainerSubView: {
        backgroundColor: '#0D0D0D',
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomColor: '#1E222A',
        borderBottomWidth: 1,
        height: 102,
        shadowColor: 'rgba(231, 244, 237, 0.08)',
        shadowOpacity: 0.1,
        shadowOffset: {
            width: 4,
            height: 4,
        },
        shadowRadius: 10,
    }
});
